<template>
    <h1>Eksponaty: <span class="acier">{{total}}</span></h1>
</template>

<script>
import { eventBus } from "@/main.js";
export default {
  name: "ShowpiecesHead",
  props: ["total"],
  mounted() {
      eventBus.$emit("headLoaded");
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Heads/ShowpiecesHead.vue